import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SelectAccountsPage } from './select-accounts.page';

const routes: Routes = [
  {
    path: '',
    component: SelectAccountsPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SelectAccountsPageRoutingModule {}
